import { postWithPrefix } from '@/utils/request';

// eslint-disable-next-line import/prefer-default-export
export async function submit(params = {}) {
  const formData = new FormData();
  formData.append('updateParam', JSON.stringify(params));
  return postWithPrefix('/purchaseorder/designersubmit', formData);
}
